import { Arrow, Link, cn } from "@jog/react-components"
import { ComponentProps } from "react"

export const ArrowLink = ({ children, href, className, ...props }: ComponentProps<typeof Link>) => (
    <div className="group mb-2.5 flex items-center text-sm">
        <Arrow />
        <Link className={cn("ml-1.5 cursor-pointer text-black no-underline", className)} href={href} {...props}>
            {children}
        </Link>
    </div>
)
